import PayOverdueBalanceDrawerDialog from '@/account/components/pay-overdue-balance-drawer-dialog';
import UpdatePayOverdueBalanceDrawerDialog from '@/account/components/update-pay-overdue-balance-drawer-dialog';
import StatusBanner from '@/common/components/status-banner';
import { getStandardCurrency } from '@/util-conversion/currency';
import { MouseEventHandler, useState } from 'react';
import { PaymentErrors } from '../../../types/pdp-action';
import { PaymentMethodConfiguration } from '@/account/types/payment-method-configuration';
import { StripeConfig } from '@/checkout/components/stripe-checkout-form';

export interface CannotOrderPayOverdueBalanceProps {
  unpaidBalance: number;
  paymentMethodConfiguration?: PaymentMethodConfiguration;
  ADYEN_ORIGIN_KEY: string;
  ADYEN_JS_SRC: string;
  SMARTYSTREETS_EMBEDDED_KEY: string;
  /** For retry payment errors */
  paymentErrors?: PaymentErrors;
  /** For update and retry errors */
  updatePaymentErrors?: PaymentErrors;
  shouldUseStripe?: boolean;
  stripeConfig?: StripeConfig;
}

export default function CannotOrderPayOverdueBalance({
  unpaidBalance,
  paymentMethodConfiguration,
  ADYEN_ORIGIN_KEY,
  ADYEN_JS_SRC,
  SMARTYSTREETS_EMBEDDED_KEY,
  paymentErrors,
  updatePaymentErrors,
  shouldUseStripe,
  stripeConfig,
}: CannotOrderPayOverdueBalanceProps) {
  const [isOpenPayOverdue, setIsOpenPayOverdue] = useState(false);
  const [isOpenUpdatePaymentAndPay, setIsOpenUpdatePaymentAndPay] = useState(false);

  const handleUpdatePaymentMethod: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    setIsOpenPayOverdue(false);
    setIsOpenUpdatePaymentAndPay(true);
  };

  const storedPaymentMethod =
    paymentMethodConfiguration?.storedPaymentMethods &&
    paymentMethodConfiguration?.storedPaymentMethods[0];

  return (
    <div className="mx-[24px] md:mx-0" data-testid="delinquency-panel">
      <StatusBanner
        variant="error"
        title={`Overdue balance of ${getStandardCurrency(unpaidBalance)}`}
        message={{
          text: (
            <p className="body">
              Select &lsquo;Pay balance&rsquo; to retry payment or update your payment
              method.
            </p>
          ),
        }}
        primaryLinkButton={{
          text: 'Pay balance...',
          button: {
            onClick: () => setIsOpenPayOverdue(true),
            type: 'secondary',
          },
        }}
      />
      <PayOverdueBalanceDrawerDialog
        unpaidBalance={unpaidBalance}
        isSelectingVehicle={true}
        cardType={storedPaymentMethod?.brand}
        cardLast4={storedPaymentMethod?.lastFour}
        open={isOpenPayOverdue}
        paymentError={paymentErrors?.error}
        handleUpdatePaymentMethod={handleUpdatePaymentMethod}
        handleClose={() => setIsOpenPayOverdue(false)}
      />
      <UpdatePayOverdueBalanceDrawerDialog
        shouldUseStripe={shouldUseStripe}
        stripeConfig={stripeConfig}
        unpaidBalance={unpaidBalance}
        open={isOpenUpdatePaymentAndPay}
        paymentMethodConfiguration={paymentMethodConfiguration}
        adyenOriginKey={ADYEN_ORIGIN_KEY}
        adyenJsSrc={ADYEN_JS_SRC}
        smartyStreetsEmbeddedKey={SMARTYSTREETS_EMBEDDED_KEY}
        error={updatePaymentErrors?.error}
        paymentError={updatePaymentErrors?.paymentMethod}
        addressErrors={updatePaymentErrors?.addressErrors}
        shouldAllowStoredPaymentMethods={false}
        handleClose={() => setIsOpenUpdatePaymentAndPay(false)}
      />
    </div>
  );
}
